enum ClaimStatus {
  Draft = 'Draft',
  Submitted = 'Submitted',
  PaymentDue = 'Payment Due',
  PaymentSubmitted = 'Payment Submitted',
  Closed = 'Closed',
  InQueue = 'In Queue',
  DecisionIssued = 'Decision Issued',
  UnderReview = 'Under Judges Review',
}
export default ClaimStatus;
